import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useDispatch, useSelector } from 'react-redux';
import { Checkbox, FormControlLabel, FormGroup, Stack, Tab, Tabs, TextField, Typography } from '@mui/material';
import './style.css'
import httpClient from '../../_util/api';
import CustomizedSnackbars from '../Snackbar/SnackBar';
import { hideLoader, showLoader } from '../../Store/mainSlice';
import { useRef } from 'react';
// import UploadImg from './UploadImg';
import { UploadImagetoFb } from '../../Hooks/uploadImage'
import { useParams } from 'react-router-dom';

export default function UploadPopup(props) {
    const id = props.id
    const { CNICNo } = useParams()
    const role = localStorage.getItem('role')
    const open = useSelector((state) => state.approvePopupOpen)
    const snackbar_Ref = useRef()
    const invoiceRef = useRef()
    const feeChallanRef = useRef()
    const applicationRef = useRef()
    const dispatch = useDispatch()
    const [scroll, setScroll] = React.useState('paper');
    const [value, setValue] = React.useState(0)
    const [studentData, setStudentData] = React.useState({
        firstName: "",
        lastName: "",
        email: "",
        gender: "",
        address: "",
        town: "",
        phoneNo_Mobile: "",
        phoneNo_Home: "",
        CNICNo: "",
        CNIC_type: "",
        CNIC_dateOfIssue: "",
        CNIC_placeOfIssue: "",
        presentHouseholdIncome: 0,
        totalFamilyMembers: 0,
        fatherName: "",
        motherName: "",
        signature: "",
        password: "",
        confirmPassword: "",
        courseTitle: "",
        class: "",
        institutionName: "",
        institutionAddress: "",
        tuttionFee: 0,
        lastInstitutionAttended: "",
        classOfLastInstitution: "",
        requestedAmount: 0,
        description: "",
        referenceName1: "",
        referenceEmail1: "",
        referencePhone1: "",
        referenceName2: "",
        referenceEmail2: "",
        referencePhone2: "",
        resultOfLastExamPic: "",
        feeVoucherPic: "",
        CNICPic: "",
        parentCNICPic: "",
        proofOfIncomePic: "",
        currentElectricBill: "",
        miscDocs: [
            {
                fileName: "",
                url: ""
            }
        ],
        invoice: {
            fileName: "",
            url: ""
        },
        feeChallans: {
            fileName: "",
            url: ""
        }
    })

    const handleClickOpen = (scrollType) => () => {
        setScroll(scrollType);
    };

    const handleClose = () => {
        props.onClose()
    };

    const getStudentDetail = async () => {
        const res = await httpClient.get(`/students/getStudentByCNIC/${CNICNo}`).catch((error) => {
            console.log("error", error.message);
        })

        if (res?.status === 200) {
            console.log("res", res.data[0])
            setStudentData(res?.data[0])
        }
    }

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const uploadPhotoHandler = (refType) => {
        const refCreator = {
            invoiceRef: invoiceRef,
            feeChallanRef: feeChallanRef,
            applicationRef: applicationRef,
        }[refType]


        if (refCreator) {
            console.log("refCreator", refCreator);
            refCreator.current.click();
        }

    }

    const handleFileChange = async (event, field) => {

        const files = event.target.files[0];

        if (files) {
            const fileType = files.type;
            if (fileType != "application/pdf") {
                alert('Please upload a PDF file.')
                return;
            }
        }
        const newFile = {}
        const getFirestorePic = await UploadImagetoFb(event);

        if (field == "miscDocs") {
            console.log("field", field)
            newFile.fileName = files["name"],
                newFile.url = getFirestorePic.url;

            if (studentData.miscDocs) {
                setStudentData((prev) => ({
                    ...prev,
                    [field]: [...prev.miscDocs, newFile]
                }))
            }
            else {
                setStudentData((prev) => ({
                    ...prev,
                    [field]: [newFile]
                })
                )
            }

        }
        else {
            newFile.fileName = files["name"]
            newFile.url = getFirestorePic.url
            setStudentData((prev) => ({ ...prev, [field]: newFile }))
        }
    }

    const submitHandler = async () => {
        dispatch(showLoader())
        const res = await httpClient.post(`/students/updateStudentData/${CNICNo}`, studentData).catch((error) => {
            dispatch(hideLoader())
            snackbar_Ref.current.showMessage("error", error?.response.data.message, "", "i-chk-circle");
        })

        if (res?.status === 200) {
            dispatch(hideLoader())
            snackbar_Ref.current.showMessage("success", res?.data.message, "", "i-chk-circle");
            setTimeout(() => {
                props.onClose()
            }, 3000);
        }
    }



    React.useEffect(() => {
        // console.log("stdId", id);
        getStudentDetail()

    }, [])


    const descriptionElementRef = React.useRef(null);
    React.useEffect(() => {
        if (open) {
            const { current: descriptionElement } = descriptionElementRef;
            if (descriptionElement !== null) {
                descriptionElement.focus();
            }
        }
    }, [open]);

    return (
        <React.Fragment>
            <CustomizedSnackbars ref={snackbar_Ref} />
            <Dialog
                open={props.open}
                onClose={handleClose}
            >
                <DialogTitle id="scroll-dialog-title"><Typography variant='h5' sx={{ fontWeight: 'bold' }}>Upload</Typography></DialogTitle>
                <DialogContent >
                    {/* <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                                <Tab label="Invoice" />
                                <Tab label="Fee Challans" />
                                <Tab label="Misc.Applications" />
                            </Tabs>

                            <UploadImg value={value} id={id} onClose={handleClose}/> */}
                    <Stack justifyContent={'space-between'} sx={{ width: '100%', height: '50vh' }}>

                        <Stack>
                            <Typography fontWeight={'bold'}>Invoice:</Typography>
                            <Stack htmlFor="upload-photo-input" flexDirection={'row'} style={{ cursor: 'pointer', border: "1px solid grey" }}>
                                <button style={{ width: '117px' }}
                                    onClick={() => uploadPhotoHandler("invoiceRef")}
                                >
                                    Choose File
                                </button>
                                <Typography className="fileName">{studentData.invoice ? studentData.invoice.fileName : ""}</Typography>
                                <input
                                    ref={invoiceRef}
                                    type="file"
                                    accept="application/pdf"
                                    onChange={(e) => handleFileChange(e, "invoice")}
                                    style={{ display: 'none' }}
                                    className="upload-photo-input"
                                />
                            </Stack>
                        </Stack>

                        <Stack>
                            <Typography fontWeight={'bold'}>Fee Challans:</Typography>
                            <Stack htmlFor="upload-photo-input" flexDirection={'row'} style={{ cursor: 'pointer', border: "1px solid grey" }}>
                                <button style={{ width: '117px' }}
                                    onClick={() => uploadPhotoHandler("feeChallanRef")}
                                >
                                    Choose File
                                </button>
                                <Typography className="fileName">{studentData.feeChallans ? studentData.feeChallans.fileName : ""}</Typography>
                                <input
                                    ref={feeChallanRef}
                                    type="file"
                                    accept="application/pdf"
                                    onChange={(e) => handleFileChange(e, "feeChallans")}
                                    style={{ display: 'none' }}
                                    className="upload-photo-input"
                                />
                            </Stack>
                        </Stack>

                        <Stack>
                            <Typography fontWeight={'bold'}>Misc.Applications:</Typography>
                            <Stack htmlFor="upload-photo-input" flexDirection={'row'} style={{ cursor: 'pointer', border: "1px solid grey" }}>
                                <button style={{ width: '117px' }}
                                    onClick={() => uploadPhotoHandler("applicationRef")}
                                >
                                    Choose File
                                </button>
                                <Typography className="fileName">
                                    {studentData.miscDocs?.map((file) => {
                                        return <span>{file.fileName + "  "}</span>
                                    })
                                    }
                                </Typography>
                                {/* <Typography className="fileName">{studentData.miscDocs ? studentData.miscDocs.fileName : ""}</Typography> */}
                                <input
                                    ref={applicationRef}
                                    type="file"
                                    accept="application/pdf"
                                    multiple
                                    onChange={(e) => handleFileChange(e, "miscDocs")}
                                    style={{ display: 'none' }}
                                    className="upload-photo-input"
                                />
                            </Stack>
                        </Stack>

                        <Button
                            variant="contained"
                            sx={{
                                backgroundColor: "#208146",
                                color: 'white',
                                width: '104px',
                                height: "5vh",
                                fontSize: '12px',
                                borderRadius: '12px',
                                "&:hover": {
                                    backgroundColor: "#208146",
                                },
                            }}

                            onClick={submitHandler}
                        >
                            Submit
                        </Button>


                    </Stack>

                </DialogContent>

            </Dialog>
            {/* )
            } */}
        </React.Fragment>
    );
}